import { type ReactNode } from "react";
import {
  CheckMarkCircleIcon,
  CheckMarkRectangleIcon,
  DocumentTextIcon,
  EyeIcon,
  PenIcon,
  RemoveCircleIcon,
  ZoomTextIcon,
} from "vega-icons";

import { NotificationContentType } from "@vega-api/generated/types/notificationContentType";
import { type NotificationResponse } from "@vega-api/generated/types/notificationResponse";

export const getNotificationIcon = (
  type: NotificationResponse["type"],
): ReactNode | undefined => {
  switch (type) {
    case NotificationContentType.GP_WORKFLOW_TASK_ASSIGNMENT:
    case NotificationContentType.COINVEST_NOTIFICATION_DEAL_CLOSED:
      return <CheckMarkRectangleIcon className="h-4 w-4" />;
    case NotificationContentType.GP_INTERNAL_NOTE_TAG:
      return <ZoomTextIcon className="h-4 w-4" />;
    case NotificationContentType.COINVEST_NOTIFICATION_ALLOCATION_ACCEPTED:
    case NotificationContentType.COINVEST_NOTIFICATION_NDA_CONFIRMED:
      return <CheckMarkCircleIcon className="h-4 w-4" />;
    case NotificationContentType.COINVEST_NOTIFICATION_ALLOCATION_REJECTED:
    case NotificationContentType.COINVEST_NOTIFICATION_ORDER_REJECTED:
      return <RemoveCircleIcon className="h-4 w-4" />;
    case NotificationContentType.COINVEST_NOTIFICATION_ORDER_SUBMITTED:
    case NotificationContentType.COINVEST_NOTIFICATION_ALLOCATION_SENT:
      return <DocumentTextIcon className="h-4 w-4" />;
    case NotificationContentType.COINVEST_NOTIFICATION_NDA_SIGNED:
    case NotificationContentType.COINVEST_NOTIFICATION_NDA_SENT:
      return <PenIcon className="h-4 w-4" />;
    case NotificationContentType.COINVEST_NOTIFICATION_DATA_ROOM_FIRST_ACCESS:
    case NotificationContentType.COINVEST_NOTIFICATION_DATA_ROOM_ACCESS_GRANTED:
    case NotificationContentType.COINVEST_NOTIFICATION_DEAL_ACCESS_GRANTED:
      return <EyeIcon className="h-4 w-4" />;
    default:
      return undefined;
  }
};
